import { Dialog, DialogContent } from '@mui/material'
import React, { useState } from 'react'
import ViewReverse from './ViewReverse'
import Text from './Text'
import { fontSizes } from '../constants/constants'
import { ReactSVG } from 'react-svg'
import icons from '../constants/icons'
import { useSelector } from 'react-redux'
import { getContentKeyAccToLang } from '../utils/utils'
import dynamicfunction from '../utils/dynamicfunction'
import CustomTabs from './CustomTabs'
import { clientDetailTabs, portfolioCashColumn, portfolioMarketColumn } from '../config/config'
import Divider from './Divider'
import CustomInput from './CustomInput'
import CustomDatePicker from './CustomDatePicker'
import CustomTable from './CustomTable'
import ViewItems from './ViewItems'

const ClientDetailModal = ({ isOpen, handleClose }) => {
    const { TextWeight, isArabic } = dynamicfunction();

    const { generalClientDetails } = useSelector((state) => state.setting);
    const { user } = useSelector((state) => state.common);
    const { authContent } = useSelector((state) => state.content);
    
    const getContentKey = (key) => {
        return getContentKeyAccToLang(authContent?.web_client_detail?.data?.attributes, key, isArabic);
    };

    const [selectedTab, setSelectedTab] = useState(clientDetailTabs(getContentKey)?.[0]);

    const username = user?.investorTypeId == 1 ? generalClientDetails?.clientNameEn?.split(' ')?.[0] : generalClientDetails?.clientNameEn;
    const usernameAr = user?.investorTypeId == 1 ? generalClientDetails?.clientNameAr?.split(' ')?.[0] : generalClientDetails?.clientNameAr;

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={"md"}>
        <DialogContent>
        <ViewReverse className={'items-center justify-between'}>
          <Text
            text={getContentKey('client_details')}
            size={fontSizes.h20}
            weight={TextWeight.headingRegular}
            color='text-blue-dark'
          />
          <ReactSVG
            src={icons.cross}
            onClick={handleClose}
            className='cursor-pointer'
          />
        </ViewReverse>

        <ViewReverse className={'mt-4 w-full justify-between items-start mb-4'}>
          <div className='px-4 py-3 bg-grey/50 rounded opacity-50'>
            <Text
              text={generalClientDetails?.clientCode}
              color='text-gray-500'
            />
          </div>

          <ViewItems className={isArabic ? 'item-start' : 'items-end'}>
            {isArabic ? (
              <Text
                text={usernameAr}
                color='text-light-blue'
                size={fontSizes.h20}
              />
            ) : (
              <Text
                text={username}
                color='text-light-blue'
                size={fontSizes.h20}
              />
            )}
          </ViewItems>
        </ViewReverse>

        <CustomTabs
          data={clientDetailTabs(getContentKey)}
          selectedTab={selectedTab}
          onPress={(val) => setSelectedTab(val)}
        />

        <div className='h-3' />

        <div className='max-h-96 overflow-y-auto'>
          {selectedTab?.id === 0 ? (
            <>
              <ViewReverse className={'gap-5 flex-wrap'}>
                <ViewReverse className={'items-center gap-2'}>
                  <Text
                    text={getContentKey('id_type')}
                    color='text-primary-light'
                  />

                  <div className='border border-grey rounded h-11 flex items-center justify-center min-w-24'>
                    <Text
                      text={generalClientDetails?.mainInfo?.idType}
                      color='text-gray-400'
                    />
                  </div>
                </ViewReverse>
                <ViewReverse className={'items-center gap-2'}>
                  <Text
                    text={getContentKey('id_number')}
                    color='text-primary-light'
                  />

                  <div className='border border-grey rounded h-11 flex items-center justify-center min-w-24'>
                    <Text
                      text={generalClientDetails?.mainInfo?.nationalId}
                      color='text-gray-400'
                    />
                  </div>
                </ViewReverse>
                <ViewReverse className={'items-center gap-2'}>
                  <Text
                    text={getContentKey('status')}
                    color='text-primary-light'
                  />

                  <div className='border border-grey rounded h-11 flex items-center justify-center min-w-24'>
                    <Text
                      text={generalClientDetails?.mainInfo?.status}
                      color='text-gray-400'
                    />
                  </div>
                </ViewReverse>
              </ViewReverse>

              <Divider />

              <ViewReverse className={'gap-4'}>
                <CustomInput
                  label={getContentKey('email')}
                  value={generalClientDetails?.mainInfo?.email}
                  isDisabled
                  isRounded
                />
                <CustomDatePicker
                  label={getContentKey('birth_date')}
                  selectedDate={generalClientDetails?.mainInfo?.dateOfBirth}
                  isDisabled
                />
              </ViewReverse>

              <ViewReverse className={'gap-4 mt-3'}>
                <CustomInput
                  label={getContentKey('address')}
                  value={generalClientDetails?.mainInfo?.address}
                  isDisabled
                  isRounded
                />
                <CustomInput
                  label={getContentKey('city')}
                  value={generalClientDetails?.mainInfo?.city}
                  isDisabled
                  isRounded
                />
              </ViewReverse>

              <ViewReverse className={'gap-4 mt-3'}>
                <CustomInput
                  label={getContentKey('po_box')}
                  value={generalClientDetails?.mainInfo?.poBox}
                  isDisabled
                  isRounded
                />
                <CustomInput
                  label={getContentKey('mobile')}
                  value={generalClientDetails?.mainInfo?.mobile}
                  isDisabled
                  isRounded
                />
              </ViewReverse>

              <ViewReverse className={'gap-4 mt-3'}>
                <CustomInput
                  label={getContentKey('telephone')}
                  value={generalClientDetails?.mainInfo?.telephone}
                  isDisabled
                  isRounded
                />
                <CustomInput
                  label={getContentKey('fax_number')}
                  value={generalClientDetails?.mainInfo?.faxNumber}
                  isDisabled
                  isRounded
                />
              </ViewReverse>
            </>
          ) : selectedTab?.id === 1 ? (
            <>
              {generalClientDetails?.portfolios?.map((item, index) => (
                <>
                  <CustomTable
                    heading={`${index + 1} - ${item?.marketAccountName}`}
                    headCells={isArabic ? portfolioMarketColumn(getContentKey)?.reverse() : portfolioMarketColumn(getContentKey)}
                    isOpen
                    isBorder={false}
                    data={[
                      {
                        marketAccountName: item?.marketAccountName,
                        tradingNumber: item?.tradingNumber,
                        investorId: item?.investorId,
                      },
                    ]}
                  />

                  <CustomTable
                    headCells={isArabic ? portfolioCashColumn(getContentKey)?.reverse() : portfolioCashColumn(getContentKey)}
                    isOpen
                    isBorder={false}
                    data={[
                      {
                        cashAccountNumber: item?.cashAccountNumber,
                        cashType: item?.cashType,
                        cashCurrency: item?.cashCurrency,
                      },
                    ]}
                  />
                </>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ClientDetailModal
